export class BSchoolService {
bSchoolList:any [] = [
 {
  "S.No.": 1,
  "Name": "IIM Ahmedabad (2022)",
  "highestSalary": 61.49,
  "avgSalary": 32.8,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-ahmedabad-2/"
 },
 {
  "S.No.": 2,
  "Name": "IIM Bangalore",
  "highestSalary": 80,
  "avgSalary": 35.31,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-bangalore/"
 },
 {
  "S.No.": 3,
  "Name": "IIM Calcutta",
  "highestSalary": 115,
  "avgSalary": 35.07,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-calcutta/"
 },
 {
  "S.No.": 4,
  "Name": "ISB Hyderabad",
  "highestSalary": 66,
  "avgSalary": 34.21,
  "Exam": "GMAT",
  "CTA": "https://www.iquanta.in/blog/isb-hyderabad/"
 },
 {
  "S.No.": 5,
  "Name": "XLRI Jamshedpur",
  "highestSalary": 78.2,
  "avgSalary": 32.7,
  "Exam": "XAT",
  "CTA": "https://www.iquanta.in/blog/xlri-jamshedpur/"
 },
 {
  "S.No.": 6,
  "Name": "IIM Lucknow",
  "highestSalary": 55,
  "avgSalary": 32.2,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-lucknow/"
 },
 {
  "S.No.": 7,
  "Name": "FMS Delhi",
  "highestSalary": 120,
  "avgSalary": 34.1,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/fms-delhi/"
 },
 {
  "S.No.": 8,
  "Name": "SP Jain",
  "highestSalary": 77.8,
  "avgSalary": 33,
  "Exam": "CAT/GMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 9,
  "Name": "IIM Kozhikode ",
  "highestSalary": 67.02,
  "avgSalary": 31.02,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-kozhikode/"
 },
 {
  "S.No.": 10,
  "Name": "IIM Indore",
  "highestSalary": 114,
  "avgSalary": 30.21,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-indore/"
 },
 {
  "S.No.": 11,
  "Name": "JBIMS ",
  "highestSalary": 35.75,
  "avgSalary": 28.02,
  "Exam": "CMAT/MAHCET",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 12,
  "Name": "MDI, Gurgaon",
  "highestSalary": 60,
  "avgSalary": 27.67,
  "Exam": "CAT/GMAT",
  "CTA": "https://www.iquanta.in/blog/mdi-gurgaon/"
 },
 {
  "S.No.": 13,
  "Name": "IIM Mumbai",
  "highestSalary": 78.2,
  "avgSalary": 27.75,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-mumbai/"
 },
 {
  "S.No.": 14,
  "Name": "IIFT-D",
  "highestSalary": 75.6,
  "avgSalary": 29.1,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 15,
  "Name": "SJMSOM, IIT Bombay",
  "highestSalary": 54,
  "avgSalary": 28.8,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/sjmsom-iit-bombay/"
 },
 {
  "S.No.": 16,
  "Name": "TISS",
  "highestSalary": 49,
  "avgSalary": 23.97,
  "Exam": "TISSNET",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 17,
  "Name": "SIBM",
  "highestSalary": 35.05,
  "avgSalary": 26.77,
  "Exam": "SNAP",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 18,
  "Name": "IIFT-K",
  "highestSalary": 75.6,
  "avgSalary": 29.1,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 19,
  "Name": "IIM Shillong",
  "highestSalary": 71.31,
  "avgSalary": 26.96,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-shillong/"
 },
 {
  "S.No.": 20,
  "Name": "NMIMS Mumbai",
  "highestSalary": 67.8,
  "avgSalary": 26.63,
  "Exam": "NMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 21,
  "Name": "DMS, IIT-D",
  "highestSalary": 41.1,
  "avgSalary": 25.8,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/dms-iit-delhi/"
 },
 {
  "S.No.": 22,
  "Name": "VGSOM IIT-KGP",
  "highestSalary": 43.37,
  "avgSalary": 22.13,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/vgsom-iit-kharagpur/"
 },
 {
  "S.No.": 23,
  "Name": "GLIM, Chennai",
  "highestSalary": 46,
  "avgSalary": 14.5,
  "Exam": "CAT/GMAT/XAT/CMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 24,
  "Name": "SCMHRD",
  "highestSalary": 67,
  "avgSalary": 23.71,
  "Exam": "SNAP",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 25,
  "Name": "IIM Raipur",
  "highestSalary": 43.43,
  "avgSalary": 21.04,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-raipur/"
 },
 {
  "S.No.": 26,
  "Name": "IMT Ghaziabad",
  "highestSalary": 34,
  "avgSalary": 17.35,
  "Exam": "CAT/XAT/GMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 27,
  "Name": "IIM Ranchi",
  "highestSalary": 35.5,
  "avgSalary": 17.3,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-ranchi/"
 },
 {
  "S.No.": 28,
  "Name": "XIMB",
  "highestSalary": 71.51,
  "avgSalary": 20.03,
  "Exam": "CAT/XAT/GMAT + NMAT for HR program",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 29,
  "Name": "IIM Trichy",
  "highestSalary": 41.61,
  "avgSalary": 20.55,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-trichy/"
 },
 {
  "S.No.": 30,
  "Name": "IIM Nagpur",
  "highestSalary": 64,
  "avgSalary": 16.74,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 31,
  "Name": "IIM Sambalpur",
  "highestSalary": 64.61,
  "avgSalary": 16.64,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-sambalpur/"
 },
 {
  "S.No.": 32,
  "Name": "IIM Vishakhapatnam",
  "highestSalary": 32.65,
  "avgSalary": 16.61,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 33,
  "Name": "IIM Kashipur",
  "highestSalary": 37,
  "avgSalary": 18.1,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-kashipur/"
 },
 {
  "S.No.": 34,
  "Name": "MICA",
  "highestSalary": 36,
  "avgSalary": 20.09,
  "Exam": "CAT/XAT + MICAT",
  "CTA": "https://www.iquanta.in/blog/mica-ahmedabad/"
 },
 {
  "S.No.": 35,
  "Name": "IIM Rohtak",
  "highestSalary": 36,
  "avgSalary": 18.73,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-rohtak/"
 },
 {
  "S.No.": 36,
  "Name": "IIT Kanpur",
  "highestSalary": 24,
  "avgSalary": 18.14,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 37,
  "Name": "DFS, DU (2022)",
  "highestSalary": 14.55,
  "avgSalary": 27.6,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 38,
  "Name": "IIM Udaipur",
  "highestSalary": 36,
  "avgSalary": 20.32,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-udaipur/"
 },
 {
  "S.No.": 39,
  "Name": "IIM Amritsar",
  "highestSalary": "25.21 (2022)",
  "avgSalary": 16.51,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 40,
  "Name": "IMI Delhi",
  "highestSalary": 50,
  "avgSalary": 17.01,
  "Exam": "CAT/XAT/GMAT/CMAT/MAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 41,
  "Name": "TAPMI",
  "highestSalary": 24.8,
  "avgSalary": 14.6,
  "Exam": "CAT/XAT/NMAT/CMAT/MAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 42,
  "Name": "DoMS, IIT Madras",
  "highestSalary": 30.6,
  "avgSalary": 20.19,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/doms-iit-madras/"
 },
 {
  "S.No.": 43,
  "Name": "SIMSREE (2022)",
  "highestSalary": 23.5,
  "avgSalary": 13.33,
  "Exam": "CAT/CMAT/MAHCET",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 44,
  "Name": "GIM Goa",
  "highestSalary": 55,
  "avgSalary": 14.87,
  "Exam": "CAT/XAT/GMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 45,
  "Name": "DBE, DU (2022)",
  "highestSalary": 21.5,
  "avgSalary": 12.54,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 46,
  "Name": "SIOM Nashik",
  "highestSalary": 30,
  "avgSalary": 14.35,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 47,
  "Name": "UBS Chandigarh",
  "highestSalary": 58.48,
  "avgSalary": 13.7,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 48,
  "Name": "NMIMS Bangalore",
  "highestSalary": 19.7,
  "avgSalary": 14,
  "Exam": "NMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 49,
  "Name": "FORE, Delhi",
  "highestSalary": 30,
  "avgSalary": 14.5,
  "Exam": "CAT/XAT/GMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 50,
  "Name": "IIT Roorkee",
  "highestSalary": 27.9,
  "avgSalary": 18.34,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 51,
  "Name": "SIBM Bangalore",
  "highestSalary": 21,
  "avgSalary": 13.48,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 52,
  "Name": "KJ Somaiya",
  "highestSalary": 22.5,
  "avgSalary": 12.28,
  "Exam": "CAT/XAT/CMAT/GMAT/NMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 53,
  "Name": "DSE DU (2022)",
  "highestSalary": 32,
  "avgSalary": 13.94,
  "Exam": "CAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 54,
  "Name": "IIM Jammu",
  "highestSalary": 64,
  "avgSalary": 16.64,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-jammu/"
 },
 {
  "S.No.": 55,
  "Name": "IRMA (2022)",
  "highestSalary": 19,
  "avgSalary": 10.4,
  "Exam": "CAT/XAT/CMAT/GMAT",
  "CTA": "Coming Soon"
 },
 {
  "S.No.": 56,
  "Name": "IIM Bodhgaya",
  "highestSalary": 30.5,
  "avgSalary": 12.36,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-bodhgaya/"
 },
 {
  "S.No.": 57,
  "Name": "IIM Sirmaur",
  "highestSalary": 64.12,
  "avgSalary": 14.45,
  "Exam": "CAT",
  "CTA": "https://www.iquanta.in/blog/iim-sirmaur/"
 }
]
tierOneColleges:any[]=[
    {
      "S.No.": 1,
      "Name": "NIT Warangal",
      "highestSalary": '88 LPA',
      "rank": "21"
     },
     {
      "S.No.": 2,
      "Name": "MNIT Jaipur",
      "highestSalary": '64 LPA',
      "rank": "46"
     },
     {
      "S.No.": 3,
      "Name": "NIT Surakthal",
      "highestSalary": '54.75 LPA',
      "rank": "10"
     },
     {
      "S.No.": 4,
      "Name": "NIT Manipur",
      "highestSalary": '47 LPA',
      "rank": "108"
     },
     {
      "S.No.": 5,
      "Name": "NIT Rourkela",
      "highestSalary": '45 LPA',
      "rank": "15"
     },
     {
      "S.No.": 6,
      "Name": "MNIT Allahabad",
      "highestSalary": '44.5 LPA',
      "rank": "47"
     },
     {
      "S.No.": 7,
      "Name": "NIT Silchar",
      "highestSalary": '44 LPA',
      "rank": "38"
     },
     {
      "S.No.": 8,
      "Name": "NIT Tiruchirappalli",
      "highestSalary": '43.31 LPA',
      "rank": "8"
     },
     {
      "S.No.": 9,
      "Name": "NIT Calicut",
      "highestSalary": '43.31 LPA',
      "rank": "31"
     },
     {
      "S.No.": 10,
      "Name": "NIT Patna",
      "highestSalary": '43.17 CPA',
      "rank": "33"
     },
  ]

  tierTwoColleges:any[]=[
    {
        "S.No.": 1,
        "Name": "NIT Kurukshetra",
        "highestSalary": '64.28 LPA',
        "rank": "81"
       },
       {
        "S.No.": 2,
        "Name": "NIT Hamirpur",
        "highestSalary": '50 LPA',
        "rank": "100"
       },
       {
        "S.No.": 3,
        "Name": "NIT Meghalaya",
        "highestSalary": '32 LPA',
        "rank": "72"
       },
       {
        "S.No.": 4,
        "Name": "NIT Patna",
        "highestSalary": '52 LPA',
        "rank": "55"
       },
       {
        "S.No.": 5,
        "Name": "NIT Raipur",
        "highestSalary": '62 LPA',
        "rank": "71"
       },
       {
        "S.No.": 6,
        "Name": "NIT Jamshedpur",
        "highestSalary": '83.40 LPA',
        "rank": "100"
       },
       {
        "S.No.": 7,
        "Name": "NIT Goa",
        "highestSalary": '26 LPA',
        "rank": "90"
       },
       {
        "S.No.": 8,
        "Name": "NIT Agartala",
        "highestSalary": '52 LPA',
        "rank": "82"
       },
       {
        "S.No.": 9,
        "Name": "NIT Puducherry",
        "highestSalary": '24.70 LPA',
        "rank": "97"
       },
       {
        "S.No.": 10,
        "Name": "NIT Manipur",
        "highestSalary": '47 LPA',
        "rank": "95"
       },
  ]

  cmattierOneColleges:any[] = [
    {
        "college_name": "Jamnalal Bajaj Institute of Management Studies (JBIMS), Mumbai",
        "courses_offered": "MMS",
        "fees": "6-7 Lakhs",
        "average_package": "26.1 LPA",
        "percentile": "99.98"
    },
    {
        "college_name": "University of Pune, Department of Management Sciences (PUMBA), Pune",
        "courses_offered": "MBA",
        "fees": "4.4 Lakhs",
        "average_package": "8.85 LPA",
        "percentile": "99.95"
    },
    {
        "college_name": "Sydenham Institute of Management Studies, Research and Entrepreneurship Education (SIMSREE), Mumbai",
        "courses_offered": "MMS",
        "fees": "4.5 Lakhs",
        "average_package": "15.59 LPA",
        "percentile": "99.94"
    },
    {
        "college_name": "Goa Institute of Management (GIM), Goa",
        "courses_offered": "PGDM",
        "fees": "21 Lakhs",
        "average_package": "11.22 LPA",
        "percentile": "99.85"
    },
    {
        "college_name": "KJ Somaiya Institute of Management, Mumbai",
        "courses_offered": "MBA, PGDM",
        "fees": "17.3 Lakhs",
        "average_package": "11 LPA",
        "percentile": "99.2"
    },
    {
        "college_name": "Great Lakes Institute of Management, Chennai",
        "courses_offered": "PGDM",
        "fees": "22 Lakhs",
        "average_package": "13.1 LPA",
        "percentile": "99.06"
    },
    {
        "college_name": "National Institute of Bank Management (NIBM), Pune",
        "courses_offered": "PGDM",
        "fees": "16 Lakhs",
        "average_package": "14.16 LPA",
        "percentile": "98.5"
    },
    {
        "college_name": "Xavier Institute of Social Service (XISS), Ranchi - BM",
        "courses_offered": "PGDM",
        "fees": "8.9 Lakhs",
        "average_package": "11 LPA",
        "percentile": "95"
    },
    {
        "college_name": "Xavier Institute of Social Service (XISS), Ranchi - HRM",
        "courses_offered": "PGDM",
        "fees": "8.9 Lakhs",
        "average_package": "7.4 LPA",
        "percentile": "95"
    },
    {
        "college_name": "Institute of Management Technology (IMT), Nagpur",
        "courses_offered": "PGDM",
        "fees": "15.12 Lakhs",
        "average_package": "10.81 LPA",
        "percentile": "90"
    },
    {
        "college_name": "IFMR Graduate School of Business at KREA University, Sri City",
        "courses_offered": "MBA",
        "fees": "14.56 Lakhs",
        "average_package": "13.5 LPA",
        "percentile": "85"
    },
    {
        "college_name": "SIES College of Management Studies (SIESCOMS), Navi Mumbai",
        "courses_offered": "PGDM",
        "fees": "6.3 Lakhs",
        "average_package": "8.11 LPA",
        "percentile": "84"
    },
    {
        "college_name": "Institute of Public Enterprise (IPE), Hyderabad",
        "courses_offered": "PGDM",
        "fees": "11.15 Lakhs",
        "average_package": "7.1 LPA",
        "percentile": "82"
    },
    {
        "college_name": "Institute of Management Technology (IMT) Hyderabad",
        "courses_offered": "PGDM",
        "fees": "12 LPA",
        "average_package": "11 LPA",
        "percentile": "82"
    },
    {
        "college_name": "KIIT School of Management (KSOM), Bhubaneswar",
        "courses_offered": "MBA",
        "fees": "13.6 Lakhs",
        "average_package": "6.5 LPA",
        "percentile": "80"
    },
    {
        "college_name": "Acharya Institute of Management and Sciences (AIMS), Bangalore",
        "courses_offered": "MBA",
        "fees": "9 Lakhs",
        "average_package": "7.5 LPA",
        "percentile": "80"
    }
]

cmattierTwoColleges:any[] = [
    {
        "college_name": "International Management Institute (IMI) Bhubaneshwar",
        "courses_offered": "PGDM",
        "fees": "12.02 LPA",
        "average_package": "7 LPA",
        "percentile": "78"
    },
    {
        "college_name": "International Management Institute (IMI) Kolkata",
        "courses_offered": "PGDM",
        "fees": "13 LPA",
        "average_package": "8.5 LPA",
        "percentile": "78"
    },
    {
        "college_name": "Birla Institute of Management Technology (BIMTECH), Greater Noida",
        "courses_offered": "PGDM",
        "fees": "14 Lakhs",
        "average_package": "11 LPA",
        "percentile": "75"
    },
    {
        "college_name": "Xavier Institute of Management and Entrepreneurship (XIME), Bengaluru",
        "courses_offered": "PGDM",
        "fees": "11 Lakhs",
        "average_package": "14.3 LPA",
        "percentile": "75"
    },
    {
        "college_name": "Birla Institute of Technology (BIT), Mesra",
        "courses_offered": "MBA",
        "fees": "5.5 Lakhs",
        "average_package": "6 LPA",
        "percentile": "75"
    },
    {
        "college_name": "Welingkar Institute of Management (WeSchool), Mumbai",
        "courses_offered": "PGDM",
        "fees": "17 Lakhs",
        "average_package": "12 LPA",
        "percentile": "70"
    },
    {
        "college_name": "SCMS Cochin School of Business, Cochin",
        "courses_offered": "PGDM",
        "fees": "8.25 Lakhs",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Trichy",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Warangal",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Silchar",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Rourkela",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Durgapur",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Kurukshetra",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "MNIT Jaipur",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Jalandhar",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "college_name": "NIT Agartala",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "6.5",
        "percentile": "70"
    },
    {
        "college_name": "NIT Hamirpur",
        "courses_offered": "MBA",
        "fees": "2.5",
        "average_package": "7",
        "percentile": "70"
    }
]

cmattierThreeColleges:any[] = [
    {
        "college_name": "Scaler School of Business",
        "courses_offered": "PGP - MT",
        "fees": "21 Lakhs",
        "average_package": "24 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Business Management & Research (IBMR), Gurgaon",
        "courses_offered": "MBA / PGDM",
        "fees": "MBA+PGPM - INR 5.34 Lakh PGDM+PGPM - INR 6.75 Lakh",
        "average_package": "INR 9.4 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Integrated Learning in Management (IILM),Greater Noida",
        "courses_offered": "MBA",
        "fees": "INR 11.7 Lakhs",
        "average_package": "INR 8 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Integrated Learning in Management (IILM), Gurgaon",
        "courses_offered": "MBA",
        "fees": "INR 12.30 Lakhs",
        "average_package": "INR 8.6 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Jaipuria institute of Management (JIM), Noida",
        "courses_offered": "PGDM",
        "fees": "INR 15.75 Lakhs",
        "average_package": "INR 11.08 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Jaipuria Institute of Management (JIM), Lucknow",
        "courses_offered": "PGDM",
        "fees": "INR 14.75 Lakh",
        "average_package": "9.05 L",
        "percentile": "40"
    },
    {
        "college_name": "Jaipuria institute of Management (JIM), Indore",
        "courses_offered": "PGDM",
        "fees": "INR 12.75 Lakh",
        "average_package": "INR 11.08 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Jaipuria institute of Management (JIM), Jaipur",
        "courses_offered": "PGDM",
        "fees": "INR 13.75 Lakh",
        "average_package": "INR 11.08 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Apeejay school of Management (ASM), Dwarka",
        "courses_offered": "PGDM",
        "fees": "INR 9.7 Lakh",
        "average_package": "INR 8.47 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Siva Sivani Institute of Management (SSIM), Hyderabad",
        "courses_offered": "PGDM",
        "fees": "INR 6.9 Lakhs",
        "average_package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Woxsen University, Hyderabad",
        "courses_offered": "MBA",
        "fees": "INR 14.4 Lakhs",
        "average_package": "INR 9.04 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Taxila Business School (Taxila), JAIPUR",
        "courses_offered": "PGDM",
        "fees": "Plan A - 9.50 Lakhs\n  Plan B - 10.20 Lakh",
        "average_package": "INR 11.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Calcutta Business School (CBS) Kolkata",
        "courses_offered": "PGDM",
        "fees": "7.45 L",
        "average_package": "7.45 L - 7.96 L",
        "percentile": "40"
    },
    {
        "college_name": "Pune Institute of Business Management (PIBM), Pune",
        "courses_offered": "PGDM / MBA",
        "fees": "INR 9.25 Lakhs",
        "average_package": "INR 9.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Akemi Business School, Pune",
        "courses_offered": "MBA",
        "fees": "MBA+MDP- INR 5.90 Lakhs",
        "average_package": "INR 6.87 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Krupanidhi college of Management (KCM), Bangalore",
        "courses_offered": "MBA/PGDM",
        "fees": "MBA-INR 5.65 Lakhs PGDM-INR 7.50 Lakhs",
        "average_package": "INR 8.67 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Finance and International Management (IFIM) Bangalore",
        "courses_offered": "MBA",
        "fees": "INR 10.00 Lakhs",
        "average_package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Kirloskar Institute Of Advanced Management Studies (KIAMS), Harihar Bangalore",
        "courses_offered": "PGDM",
        "fees": "INR 10.85 Lakhs",
        "average_package": "INR 8.50 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Soundarya Institute of Management & Science (SIMS), Bangalore",
        "courses_offered": "MBA",
        "fees": "INR 5.50 Lakhs",
        "average_package": "INR 2.64 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Ramaiah Institute of Management Studies and Sciences (RIMS), Bangalore",
        "courses_offered": "PGDM",
        "fees": "INR 8.41 Lakhs",
        "average_package": "INR 6.48 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Sandip University, Sijoul Bihar",
        "courses_offered": "MBA",
        "fees": "2.20 LAKHS",
        "average_package": "INR 2 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Firebird Institute of Research in Management (FIRM), Coimbatore, Chennai",
        "courses_offered": "PGDM",
        "fees": "INR 9.90 Lakh",
        "average_package": "INR 6.0 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Doon Business School (DBS), Dehrahun",
        "courses_offered": "MBA/PGDM",
        "fees": "MBA-INR 6.50 Lakhs PGDM-INR 6.74 Lakhs",
        "average_package": "INR 8.75 LPA",
        "percentile": "40"
    },
    {
        "college_name": "LLOYD Business School, Greater Noida",
        "courses_offered": "MBA / PGDM",
        "fees": "Dual Specialization (Without Analytics) - 8 Lakh\n  Dual Specialization (With Analytics) - 8.50 Lakh",
        "average_package": "INR 6.58 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Asian Business School (ABS), Noida",
        "courses_offered": "PGDM",
        "fees": "INR 9.00 Lakhs",
        "average_package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "college_name": "J K Business School (JKBS), Gurugram New Delhi",
        "courses_offered": "PGDM",
        "fees": "INR 7.99 Lakhs",
        "average_package": "INR 7.0 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Technology and Science (ITS), Gaziabaad",
        "courses_offered": "MBA/PGDM",
        "fees": "MBA- INR 3.44 Lakhs PGDM-INR 6.40 Lakh",
        "average_package": "INR 5.65 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Jaipuria institute of Management (JIM), Ghaziabad",
        "courses_offered": "MBA / PGDM",
        "fees": "INR MBA-4.50 lakhs,INR PGDM-8.20 Lakhs",
        "average_package": "INR 5.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Integrated Learning in Management (IILM), Lodhi Road New Delhi",
        "courses_offered": "PGDM",
        "fees": "INR 12.30 Lakhs",
        "average_package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "New Delhi Institute of Management (NDIM), New Delhi",
        "courses_offered": "PGDM",
        "fees": "INR 12.75 Lakh",
        "average_package": "INR 10 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Asia Pasific institute of management (APIM), New Delhi",
        "courses_offered": "MBA - Healthcare Mangement-RUDN University/PGDM",
        "fees": "INR 11.50 Lakhs",
        "average_package": "INR 8.11 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Shoolini University, Solan",
        "courses_offered": "MBA",
        "fees": "INR 7.5 Lakhs",
        "average_package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Vignana Jyothi Institute Of Management\n  (VJIM), Hyderabad",
        "courses_offered": "PGDM",
        "fees": "INR 8.6 Lakhs",
        "average_package": "INR 8.3 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Vishwa Vishwani Institute Of Management, Hyderabad",
        "courses_offered": "MBA / PGDM",
        "fees": "INR 7.4 Lakhs",
        "average_package": "INR 6 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Prestige University, Indore",
        "courses_offered": "MBA",
        "fees": "INR 11 Lakhs",
        "average_package": "INR 5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Globsyn Business School (GBS), Kolkata",
        "courses_offered": "PGDM, Global MBA ,",
        "fees": "8.7 L",
        "average_package": "7.39 L",
        "percentile": "40"
    },
    {
        "college_name": "St. Xavier Business School, Kolkata",
        "courses_offered": "MBA",
        "fees": "INR 10.80 Lakh",
        "average_package": "7.5 L",
        "percentile": "40"
    },
    {
        "college_name": "Praxis Business School, Kolkata",
        "courses_offered": "PGDM, PGPDS",
        "fees": "INR 11.30 Lakh",
        "average_package": "8 L",
        "percentile": "40"
    },
    {
        "college_name": "Swami Vivekanand Institute of Management and Coumputer Science (SVIMCS), Kolkata",
        "courses_offered": "MBA",
        "fees": "INR 5.20 Lakh",
        "average_package": "5 - 6 L",
        "percentile": "40"
    },
    {
        "college_name": "Adamas University, Kolkata",
        "courses_offered": "MBA",
        "fees": "INR 6.37 Lakh",
        "average_package": "4.5 L",
        "percentile": "40"
    },
    {
        "college_name": "IQ City United World School of Business (UW), Kolkata",
        "courses_offered": "MBA+PGP",
        "fees": "INR 7.20 Lakh",
        "average_package": "6 L",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Management Study (IMS), Kolkata",
        "courses_offered": "MBA",
        "fees": "MBA - 5.75 Lakh\n  MBA (Blended) - 3.75 Lakh",
        "average_package": "2.40 L",
        "percentile": "40"
    },
    {
        "college_name": "Bengal Institute of Business Studies (BIBS), Kolkata",
        "courses_offered": "MBA+PGP",
        "fees": "MBA - 6.88 Lakh\n  MBA (Data Analytics) - 7.38 Lakh\n  Executive MBA - 4.2 Lakh",
        "average_package": "6 L",
        "percentile": "40"
    },
    {
        "college_name": "IILM Acadmy of Higher Learning, Lucknow",
        "courses_offered": "PGDM",
        "fees": "6.90 L",
        "average_package": "6 L",
        "percentile": "40"
    },
    {
        "college_name": "JS Kothari Business School, (JSKBS), Mumbai",
        "courses_offered": "PGDM",
        "fees": "6.75 L",
        "average_package": "6.5 L",
        "percentile": "40"
    },
    {
        "college_name": "Institute for Technology and Management (ITM), Navi Mumbai",
        "courses_offered": "MBA",
        "fees": "INR 12.45 Lakh",
        "average_package": "INR 8.65 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Amity University, Mumbai",
        "courses_offered": "MBA",
        "fees": "INR 4.96-6.52 Lakhs",
        "average_package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Uma Krishna Shetty Institute of Management Studies and Research (UKS), Mumbai",
        "courses_offered": "PGDM",
        "fees": "INR 6 - 6.50 Lakhs",
        "average_package": "INR 5.75 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Ajeenkya DY Patil University (ADYPU), Lohegaon Pune",
        "courses_offered": "MBA",
        "fees": "INR 7 Lakhs",
        "average_package": "INR 5.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Sandip University, Nasik",
        "courses_offered": "MBA",
        "fees": "MBA- 2.60 Lakhs\n  New Age MBA- 4.90 Lakhs",
        "average_package": "INR 4.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Lexicon MILE - Management Institute of Leadership and Excellence (MILE), Pune",
        "courses_offered": "PGDM",
        "fees": "INR 10.50 Lakhs",
        "average_package": "INR 8.27 LPA",
        "percentile": "40"
    },
    {
        "college_name": "MITCON (MIMA), Pune",
        "courses_offered": "PGDM",
        "fees": "PGDM - 7.65 Lakh\n  PGDM (Agri. & Pharma) - 6.70 Lakh",
        "average_package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Pune Business School (PBS) Pune",
        "courses_offered": "PGDM",
        "fees": "INR 5.90 Lakhs",
        "average_package": "INR 6.8 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Pimpri Chinchawad University (PCU), Pune",
        "courses_offered": "MBA",
        "fees": "INR 5 Lakhs",
        "average_package": "INR 5.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Suryadatta Institute of Business Management, Pune",
        "courses_offered": "MBA",
        "fees": "INR 5 Lakhs",
        "average_package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Kirloskar Institute Of Advanced Management Studies (KIAMS), Pune",
        "courses_offered": "PGDM",
        "fees": "INR 12.60 Lakhs including lodging",
        "average_package": "INR 8.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Karnataka College of Management (KCM), Banglore",
        "courses_offered": "MBA",
        "fees": "INR 6.95 Lakh",
        "average_package": "INR 7.2 LPA",
        "percentile": "40"
    },
    {
        "college_name": "SOIL Institute of Management, Gurugram",
        "courses_offered": "PGDM",
        "fees": "INR 15.80 Lakh",
        "average_package": "10.3 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Mangalmay Institute of Management & Technology (MIMT)",
        "courses_offered": "MBA & MBA++",
        "fees": "INR MBA 3.09 Lakh & MBA++ 5.25 Lakh",
        "average_package": "5.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "DIT University, Dehradun",
        "courses_offered": "MBA",
        "fees": "5.5 Approx",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "G D Goenka University",
        "courses_offered": "MBA",
        "fees": "MBA - 8.50 Lakh\n  MBA in Fin. - 9 Lakh\n  MBA in BA - 10.50 Lakh",
        "average_package": "7 Lakh",
        "percentile": "40"
    },
    {
        "college_name": "Institute of Engineering & Management (IEM), Kolkata",
        "courses_offered": "MBA",
        "fees": "MBA - 8 Lakh",
        "average_package": "14 Lakh",
        "percentile": "40"
    },
    {
        "college_name": "RIT (Roorkee Institute of Technology)",
        "courses_offered": "MBA",
        "fees": "â‚¹1,75,000 per year",
        "average_package": "7 lakh",
        "percentile": "40"
    },
    {
        "college_name": "Chanakya University",
        "courses_offered": "",
        "fees": "",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "IBI B School",
        "courses_offered": "",
        "fees": "",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "IMM- Institute of Marketing & Management",
        "courses_offered": "",
        "fees": "",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "Sparsh Global Business School",
        "courses_offered": "",
        "fees": "",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "Quantum University",
        "courses_offered": "",
        "fees": "",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "Karnavati University",
        "courses_offered": "",
        "fees": "",
        "average_package": "",
        "percentile": "40"
    },
    {
        "college_name": "Accurate B School",
        "courses_offered": "MBA",
        "fees": "3 LAKHS",
        "average_package": "4.5 LPA",
        "percentile": "40"
    },
    {
        "college_name": "AIMS B School Pune",
        "courses_offered": "mba",
        "fees": "3.9 lakhs",
        "average_package": "5.35 lpa",
        "percentile": "40"
    },
    {
        "college_name": "St. Wilfredâ€™s College of Management Studies",
        "courses_offered": "PGDM",
        "fees": "INR 7.9 Lakh",
        "average_package": "4 lpa",
        "percentile": "40"
    },
    {
        "college_name": "Ganpat University",
        "courses_offered": "MBA",
        "fees": "2.25 & 2.60 Lakh",
        "average_package": "4.05 lpa",
        "percentile": "40"
    },
    {
        "college_name": "St Kabir institute of Professional studies",
        "courses_offered": "PGDM",
        "fees": "6.25 lakhs",
        "average_package": "5.5 lpa",
        "percentile": "40"
    },
    {
        "college_name": "Silver Oak University",
        "courses_offered": "mba",
        "fees": "3 lakhs",
        "average_package": "10 LPA",
        "percentile": "40"
    },
    {
        "college_name": "Parul University",
        "courses_offered": "MBA",
        "fees": "3.84 LAKHS",
        "average_package": "3.6. LPA",
        "percentile": "40"
    },
    {
        "college_name": "FMS Jaipur (IIRM Jaipur Campus)",
        "courses_offered": "PGDM",
        "fees": "8 lakhs",
        "average_package": "7 lpa",
        "percentile": "40"
    },
    {
        "college_name": "Narayana Business School",
        "courses_offered": "PGDM",
        "fees": "9.85 lakhs",
        "average_package": "8.4 lpa",
        "percentile": "40"
    }
]

seccutoff:any [] = [
    {
     "S.No.": 1,
     "Name": "FMS Delhi",
     "highestSalary": 120,
     "avgSalary": 34.1,
     "Exam": "CAT",
     "CTA": "Coming Soon"
    },
    {
     "S.No.": 2,
     "Name": "DMS IIT Delhi",
     "highestSalary": 41.1,
     "avgSalary": 25.8,
     "Exam": "CAT",
     "CTA": "Coming Soon"
    },
    {
        "S.No.": 3,
        "Name": "SIBM Pune",
        "highestSalary": 35.05,
        "avgSalary": 26.77,
        "Exam": "SNAP",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 4,
        "Name": "VGSoM IIT Kharagpur",
        "highestSalary": 43.37,
        "avgSalary": 22.13,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 5,
        "Name": "MHRM IIT Kharagpur",
        "highestSalary": 19,
        "avgSalary": 13.21,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 6,
        "Name": "SCMHRD Pune",
        "highestSalary": 67,
        "avgSalary": 23.71,
        "Exam": "SNAP",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 7,
        "Name": "MICA Ahmedabad",
        "highestSalary": 36,
        "avgSalary": 20.09,
        "Exam": "CAT/XAT+MICAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 8,
        "Name": "IMT Ghaziabad",
        "highestSalary": 35,
        "avgSalary": 17.34,
        "Exam": "CAT/XAT/GMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 9,
        "Name": "GLIM Chennai",
        "highestSalary": 46,
        "avgSalary": 14.5,
        "Exam": "CAT/XAT/GMAT/CMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 10,
        "Name": "DoMS IIT Madras",
        "highestSalary": 30.06,
        "avgSalary": 20.19,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 11,
        "Name": "GIM Goa",
        "highestSalary": 55,
        "avgSalary": 14.87,
        "Exam": "CAT/XAT/GMAT/CMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 12,
        "Name": "IRMA Anand",
        "highestSalary": 19,
        "avgSalary": 10.4,
        "Exam": "CAT/XAT/CMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 13,
        "Name": "IMI Delhi",
        "highestSalary": 50,
        "avgSalary": 17.01,
        "Exam": "CAT/XAT/GMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 14,
        "Name": "SDA Bocconi",
        "highestSalary": 36.50,
        "avgSalary": 15.10,
        "Exam": "CAT/NMAT/GMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 15,
        "Name": "FORE Delhi",
        "highestSalary": 30,
        "avgSalary": 14.5,
        "Exam": "CAT/XAT/GMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 16,
        "Name": "KJSIM Mumbai",
        "highestSalary": 22.8,
        "avgSalary": 12.28,
        "Exam": "CAT/XAT/GMAT/CMAT/NMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 17,
        "Name": "IIT Roorkee",
        "highestSalary": 27.9,
        "avgSalary": 18.34,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 18,
        "Name": "IIT Kanpur",
        "highestSalary": 24,
        "avgSalary": 18.14,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 19,
        "Name": "DSE Delhi",
        "highestSalary": 32,
        "avgSalary": 13.94,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 20,
        "Name": "UBS Chandigarh",
        "highestSalary": 58.48,
        "avgSalary": 13.7,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    }
   ]
badacads:any [] = [
    {
     "S.No.": 1,
     "Name": "XLRI Jamshedpur",
     "highestSalary": 78.2,
     "avgSalary": 32.7,
     "Exam": "XAT",
     "CTA": "Coming Soon"
    },
    {
     "S.No.": 2,
     "Name": "FMS Delhi",
     "highestSalary": 120,
     "avgSalary": 34.1,
     "Exam": "CAT",
     "CTA": "Coming Soon"
    },
    {
        "S.No.": 3,
        "Name": "MDI Gurgaon",
        "highestSalary": 60,
        "avgSalary": 27.67,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 4,
        "Name": "IIFT Delhi",
        "highestSalary": 29.1,
        "avgSalary": 75.6,
        "Exam": "CUET PG",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 5,
        "Name": "SJMSoM, IIT-B",
        "highestSalary": 54,
        "avgSalary": 28.8,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 6,
        "Name": "SIBM Pune",
        "highestSalary": 35.05,
        "avgSalary": 26.77,
        "Exam": "SNAP",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 7,
        "Name": "NMIMS Mumbai",
        "highestSalary": 67.8,
        "avgSalary": 26.63,
        "Exam": "NMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 8,
        "Name": "DMS, IIT-D",
        "highestSalary": 41.1,
        "avgSalary": 25.8,
        "Exam": "CAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 9,
        "Name": "SCMHRD Pune",
        "highestSalary": 67,
        "avgSalary": 23.71,
        "Exam": "SNAP",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 10,
        "Name": "XIM Bhubaneshwar",
        "highestSalary": 71.51,
        "avgSalary": 20.03,
        "Exam": "XAT/CAT/NMAT/XGMT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 11,
        "Name": "SDA Bocconi",
        "highestSalary": 36.50,
        "avgSalary": 15.10,
        "Exam": "CAT/NMAT/GMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 12,
        "Name": "FORE Delhi",
        "highestSalary": 30,
        "avgSalary": 14.5,
        "Exam": "CAT/XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 13,
        "Name": "IMT Ghaziabad",
        "highestSalary": 35,
        "avgSalary": 17.34,
        "Exam": "CAT/XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 14,
        "Name": "GLIM Chennai",
        "highestSalary": 46,
        "avgSalary": 14.5,
        "Exam": "CAT/XAT/GMAT/CMAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 15,
        "Name": "KJSIM Mumbai",
        "highestSalary": 22.8,
        "avgSalary": 12.28,
        "Exam": "CAT/XAT/GMAT/CMAT/NMAT",
        "CTA": "Coming Soon"
    }
   ]
viaxat:any [] = [
    {
     "S.No.": 1,
     "Name": "XLRI Jamshedpur",
     "highestSalary": 78.2,
     "avgSalary": 32.7,
     "Exam": "XAT",
     "CTA": "Coming Soon"
    },
    {
     "S.No.": 2,
     "Name": "XLRI Delhi",
     "highestSalary": 78.2,
     "avgSalary": 32.7,
     "Exam": "XAT",
     "CTA": "Coming Soon"
    },
    {
        "S.No.": 3,
        "Name": "XIM Bhubaneshwar",
        "highestSalary": 71.51,
        "avgSalary": 20.03,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 4,
        "Name": "MICA Ahmedabad",
        "highestSalary": 36,
        "avgSalary": 20.09,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 5,
        "Name": "IMT Ghaziabad",
        "highestSalary": 34,
        "avgSalary": 17.35,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 6,
        "Name": "IMI New Delhi",
        "highestSalary": 50,
        "avgSalary": 17.01,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 7,
        "Name": "GLIM Chennai",
        "highestSalary": 46,
        "avgSalary": 19,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 8,
        "Name": "IRMA Anand",
        "highestSalary": 19,
        "avgSalary": 10.4,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 9,
        "Name": "FORE Delhi",
        "highestSalary": 30,
        "avgSalary": 14.5,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 10,
        "Name": "BITSoM Mumbai",
        "highestSalary": 50.1,
        "avgSalary": 23.85,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 11,
        "Name": "TAPMI Manipal",
        "highestSalary": 24.8,
        "avgSalary": 14.6,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 12,
        "Name": "GIM Goa",
        "highestSalary": 55,
        "avgSalary": 14.87,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 13,
        "Name": "KJSIM Mumbai",
        "highestSalary": 22.5,
        "avgSalary": 12.28,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 14,
        "Name": "LBSIM Delhi",
        "highestSalary": 24.75,
        "avgSalary": 12.42,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 15,
        "Name": "BIMTECH Greater Noida",
        "highestSalary": 23.43,
        "avgSalary": 11.25,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 16,
        "Name": "LIBA Chennai",
        "highestSalary": 20.5,
        "avgSalary": 11,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    },
    {
        "S.No.": 17,
        "Name": "IFMR  Chennai",
        "highestSalary": 22.90,
        "avgSalary": 13.50,
        "Exam": "XAT",
        "CTA": "Coming Soon"
    }
   ]

cuetcutoff:any [] = [
    {
     "S.No.": 1,
     "Name": "SRCC",
     "highestSalary": 35,
     "avgSalary": 12,
     "Cutoff":782,
    //  "Exam": "CAT",
    //  "CTA": "Coming Soon"
    },
    {
     "S.No.": 2,
     "Name": "St. Stephens",
     "highestSalary": 25,
     "avgSalary": 8.8,
     "Cutoff":776,
    //  "Exam": "CAT",
    //  "CTA": "Coming Soon"
    },
    {
        "S.No.": 3,
        "Name": "LSR(W)",
        "highestSalary": 48.4,
        "avgSalary": 14,
        "Cutoff":772,
        // "Exam": "SNAP",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 4,
        "Name": "Hindu",
        "highestSalary": 36.5,
        "avgSalary": 10.80,
        "Cutoff":770,
        // "Exam": "CAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 5,
        "Name": "Miranda(W)",
        "highestSalary": 21.54,
        "avgSalary": 11,
        "Cutoff":770,
        // "Exam": "CAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 6,
        "Name": "Hansraj",
        "highestSalary": 36.5,
        "avgSalary": 7.9,
        "Cutoff":768,
        // "Exam": "SNAP",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 7,
        "Name": "Kirorimal",
        "highestSalary": 36.5,
        "avgSalary": 8,
        "Cutoff":764,
        // "Exam": "CAT/XAT+MICAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 8,
        "Name": "Venky",
        "highestSalary": 38,
        "avgSalary": 10,
        "Cutoff":764,
        // "Exam": "CAT/XAT/GMAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 9,
        "Name": "Ramjas",
        "highestSalary": 19.25,
        "avgSalary": 7,
        "Cutoff":760,
        // "Exam": "CAT/XAT/GMAT/CMAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 10,
        "Name": "DRC(W)",
        "highestSalary": 21.5,
        "avgSalary": 6.5,
        "Cutoff":758,
        // "Exam": "CAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 11,
        "Name": "ARSD",
        "highestSalary": 18,
        "avgSalary": 4,
        "Cutoff":756,
        // "Exam": "CAT/XAT/GMAT/CMAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 12,
        "Name": "IPCW(W)",
        "highestSalary": 21,
        "avgSalary": 5.22,
        "Cutoff":750,
        // "Exam": "CAT/XAT/CMAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 13,
        "Name": "SGTBK",
        "highestSalary": 12,
        "avgSalary": 5,
        "Cutoff":748,
        // "Exam": "CAT/XAT/GMAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 14,
        "Name": "Gargi(W)",
        "highestSalary": 21,
        "avgSalary": 5.35,
        "Cutoff":742,
        // "Exam": "CAT/XAT/GMAT",
        // "CTA": "Coming Soon"
    },
    {
        "S.No.": 15,
        "Name": "SBSC",
        "highestSalary": 23,
        "avgSalary": 6,
        "Cutoff":736,
        // "Exam": "CAT/XAT/GMAT/CMAT/NMAT",
        // "CTA": "Coming Soon"
    },
    // {
    //     "S.No.": 16,
    //     "Name": "IIT Roorkee",
    //     "highestSalary": 27.9,
    //     "avgSalary": 18.34,
    //     "Exam": "CAT",
    //     "CTA": "Coming Soon"
    // },
    // {
    //     "S.No.": 17,
    //     "Name": "IIT Kanpur",
    //     "highestSalary": 24,
    //     "avgSalary": 18.14,
    //     "Exam": "CAT",
    //     "CTA": "Coming Soon"
    // },
    // {
    //     "S.No.": 18,
    //     "Name": "DSE Delhi",
    //     "highestSalary": 32,
    //     "avgSalary": 13.94,
    //     "Exam": "CAT",
    //     "CTA": "Coming Soon"
    // },
    // {
    //     "S.No.": 19,
    //     "Name": "UBS Chandigarh",
    //     "highestSalary": 58.48,
    //     "avgSalary": 13.7,
    //     "Exam": "CAT",
    //     "CTA": "Coming Soon"
    // }
]

xatBschools:any = [
    {
      "name": "XLRI BM",
      "highestSalary": "75",
      "avgSalary": "29.89"
    },
    {
      "name": "XLRI HRM",
      "highestSalary": "75",
      "avgSalary": "29.89"
    },
    {
      "name": "XIMB",
      "highestSalary": "71.51",
      "avgSalary": "20.04"
    },
    {
      "name": "IMT Ghaziabad",
      "highestSalary": "34",
      "avgSalary": "17.25"
    },
    {
      "name": "GIM Goa",
      "highestSalary": "29",
      "avgSalary": "15.6"
    },
    {
      "name": "FORE Delhi",
      "highestSalary": "70",
      "avgSalary": "16.01	"
    },
    {
      "name": "IRMA",
      "highestSalary": "31.16",
      "avgSalary": "14.14"
    },
    {
      "name": "IMI Delhi",
      "highestSalary": "70.95",
      "avgSalary": "16.60"
    },
    {
      "name": "GLIM",
      "highestSalary": "46",
      "avgSalary": "14.50"
    },
  
  ]

}